<template>

    <div>

        <table class="table border-bottom" style="margin-bottom: 0px;font-size: .85rem;">
            <tbody>

            <tr class="info-row">
                <td colspan="2" class="editor-content bg-primary text-white"><strong>Nav</strong></td>
            </tr>

            <tr v-if="navRow.background === undefined || navRow.background.type === 'color'">
                <td class="editor-content editor-label">Bg Color</td>
                <td class="editor-content">
                    <color-picker :color-object="navRow.background" color-field="color" class="mt-1" :shift-left="true"></color-picker>
                </td>
            </tr>

            <tr>
                <td class="editor-content editor-label">Container</td>
                <td class="editor-content">
                    <input type="checkbox" v-model="navRow.includeContainer">
                </td>
            </tr>

            <tr v-if="navRow.columns.length == 1">
                <td class="editor-content editor-label">Align</td>
                <td class="editor-content">
                    <select class="form-control editor-form editor-select" v-model="navRow.justify">
                        <option>left</option>
                        <option>right</option>
                    </select>
                </td>
            </tr>

            <tr>
                <td class="editor-content editor-label">Shadow</td>
                <td class="editor-content">
                    <input type="checkbox" v-model="navRow.shadow">
                </td>
            </tr>

            <tr>
                <td class="editor-content editor-label">Stick to Top</td>
                <td class="editor-content">
                    <input type="checkbox" v-model="navRow.sticky">
                </td>
            </tr>

<!--            <tr>-->
<!--                <td class="editor-content editor-label">Include Banner</td>-->
<!--                <td class="editor-content">-->
<!--                    <input type="checkbox" v-model="navRow.banner" @change="onBannerChanged">-->
<!--                </td>-->
<!--            </tr>-->

            </tbody>
        </table>

    </div>
</template>

<script>
    import PageFactory from "../../utils/PageFactory";
    import MarginSelector from "./MarginSelector.vue";
    import ColorPicker from "../../components/ColorPicker.vue";

    export default {
        name: 'NavbarProperties',
        components: {ColorPicker, MarginSelector},
        props: ['layout', 'page'],
        data() {
            return {
                model: webase.model,
                factory: new PageFactory(),
                bannerRow: null
            }
        },
        computed: {
            navRow() {
                return this.layout.rows[this.layout.rows.length - 1]
            }
        },
        methods: {
            onBackgroundClick() {
                webase.eventDispatcher.emit('updateBackgroundClick')
            },
            onEditPatternClick() {
                webase.eventDispatcher.emit('editBackgroundPatternClick')
            },
            onBgTypeChange() {
                if (this.navRow.background.type === 'image') {
                    this.onBackgroundClick()
                } else if (this.navRow.background.type === 'pattern') {
                    this.onEditPatternClick()
                }
            },
            onBannerChanged() {
                if(this.navRow.banner && this.layout.rows.length == 1) {

                    if(this.bannerRow === null) {
                        let labelColumn = this.factory.createLabelColumn('12', 'New Row')
                        let row = this.factory.createRow()
                        row.columns.push(labelColumn)
                        this.bannerRow = row
                    }

                    this.layout.rows.splice(0, 0, this.bannerRow)
                }
                else if (!this.navRow.banner && this.layout.rows.length == 2) {
                    this.layout.rows.splice(0, 1)
                }
            }
        }
    }
</script>
